type Props = {
  size?: number;
  className?: string;
  title?: string;
};

/**
 * Positive Recruitment brand mark.
 * Wireframe sphere (lime) with a single radial indicator (white dot, lime arm)
 * - recolored from the source logo to match the site palette.
 */
export default function BrandMark({ size = 40, className, title = "Positive Recruitment" }: Props) {
  const lime = "#BDFF00";
  const limeSoft = "rgba(189,255,0,0.55)";
  const limeFaint = "rgba(189,255,0,0.28)";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <defs>
        <radialGradient id="prGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="rgba(189,255,0,0.18)" />
          <stop offset="70%" stopColor="rgba(189,255,0,0)" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="46" fill="url(#prGlow)" />
      {/* Outer sphere */}
      <circle cx="50" cy="50" r="38" fill="none" stroke={lime} strokeWidth="1" />
      {/* Latitude ellipses */}
      {[8, 18, 28, 36].map((ry) => (
        <ellipse key={`lat-${ry}`} cx="50" cy="50" rx="38" ry={ry} fill="none" stroke={limeSoft} strokeWidth="0.6" />
      ))}
      {/* Longitude ellipses */}
      {[8, 18, 28, 36].map((rx) => (
        <ellipse key={`lon-${rx}`} cx="50" cy="50" rx={rx} ry="38" fill="none" stroke={limeFaint} strokeWidth="0.6" />
      ))}
      {/* Diagonal cross */}
      <line x1="14" y1="50" x2="86" y2="50" stroke={limeFaint} strokeWidth="0.5" />
      <line x1="50" y1="14" x2="50" y2="86" stroke={limeFaint} strokeWidth="0.5" />
      {/* Indicator arm */}
      <line x1="12" y1="50" x2="50" y2="50" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="square" />
      {/* Core dot */}
      <circle cx="50" cy="50" r="4" fill="#FFFFFF" />
      <circle cx="50" cy="50" r="2" fill={lime} />
    </svg>
  );
}
